export const FIRSTTIMEVISITORTOURVISIBLE = "FIRSTTIMEVISITORTOURVISIBLE";
export const FIRSTTIMEVISITORMODAL = "FIRSTTIMEVISITORMODAL";
export const PRIVATE_BLOCKCHAIN_FIRST = "PRIVATE_BLOCKCHAIN_FIRST"
